<template>
    <div v-if="items.length > 0" class="flex-grow-1">
        <div class="text-primary fw-bold text-md-end">
            <i class="bi bi-info-circle-fill" />
            <span 
                v-if="$validateText(disclosureButtonText)" 
                class="cursor-pointer " 
                @click="isOpen = true"
            >
                {{ disclosureButtonText }}
            </span>
        </div>
        <div 
            v-show="isOpen" 
            class="position-fixed justify-content-center align-items-center top-0 start-0 w-100 h-100 zi-3"
            :class="{ 'd-flex': isOpen }"
        >
            <div class="position-relative w-100 max-wpx-md-500 h-75 h-md-100 max-hpx-md-500 zi-3 p-3 p-md-0">
                <div class="position-absolute top-0 end-0 p-3 mt-3 m-md-0 me-3 cursor-pointer" @click="isOpen = false">
                    <i class="bi bi-x-lg text-dark" />
                </div>
                <div class="rounded w-md-100 h-100 bg-white d-flex flex-column gap-2 text-start">
                    <h2 v-if="$validateText(disclosureHeader)" class="p-3 mb-0 border-bottom border-4 border-primary text-primary">
                        {{ disclosureHeader }}
                    </h2>
                    <div class="accordion accordion-flush accordion-lg overflow-auto contain-overscroll px-4 px-md-3 py-3 pt-0 fs-7 scrollbar-gutter-stable">
                        <important-disclosure-item
                            v-for="(item, index) in items" 
                            :key="`disclosure_item_${index}`"
                            :header="item.label" 
                            :text="item.text"
                            :icon="item.icon"
                        />
                    </div>
                </div>
            </div>
            <div 
                class="position-fixed top-0 start-0 w-100 h-100 bg-soft-dark zi-2" 
                @click="isOpen = false" 
            />
        </div>
    </div>
</template>

<script>
import ImportantDisclosureItem from '@/components/ImportantDisclosureItem.vue';

export default {
    components: { 
        ImportantDisclosureItem
    },
    data() {
        return {
            isOpen: false,
        };
    },
    computed: {
        settings() {
            return this.$store.state.settings;
        },
        disclosureHeader() {
            return this.settings.important_disclosure_h2;
        },
        disclosureButtonText() {
            return this.settings.important_disclosure_button;
        },
        settingsItems() {
            return this.settings.important_disclosure_rows;
        },
        items() {
            const rows = this.settingsItems
                .map(row => {
                    return {
                        label: row.label,
                        text: row.text,
                        icon: row.icon && `bi ${row.icon}`
                    };
                })
                .filter(item => this.$validateText(item.text) && this.$validateText(item.label));
            return rows;
        }
    },
    mounted() {
        document.addEventListener('keydown', this.escapeHandler);
    },
    unmounted() {
        document.removeEventListener('keydown', this.escapeHandler);
    },
    methods: {
        escapeHandler(e) {
            if (e.key === 'Escape' && this.isOpen) {
                this.isOpen = false;
            }
        }
    }
};
</script>